export function resolveDistanceRowId(row, activeCheckin) {
  const id =
    row?.id ??
    row?.distance_id ??
    activeCheckin?.distance_id ??
    activeCheckin?.id;
  if (id == null || id === '') return null;
  return id;
}

export function getSiteLatLng(siteData) {
  const lat = Number(siteData?.lead?.latitude);
  const lng = Number(siteData?.lead?.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}

export function isCheckoutApiSuccess(body) {
  if (!body) return false;
  return (
    body.status === 0 ||
    body.response?.status === true ||
    body.response?.data === true ||
    body.data === true
  );
}

export function checkoutErrorMessage(body, fallback = 'Check-out failed. Please try again.') {
  return body?.message || body?.response?.message || fallback;
}

/** GET distance rows may be an object or a list. Always return one row. */
export function pickDistanceRow(raw, ticketId) {
  if (!Array.isArray(raw)) {
    return raw && typeof raw === 'object' ? raw : {};
  }
  if (ticketId != null && ticketId !== '') {
    const match = raw.find(
      (row) =>
        String(row?.task_id) === String(ticketId) ||
        String(row?.ticket_id) === String(ticketId) ||
        String(row?.manage_id) === String(ticketId)
    );
    if (match) return match;
  }
  const active = raw.find((row) => !row?.checkout_lat);
  return active || raw[0] || {};
}
